import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchaseOrderItem, PurchaseOrderItemCreate, PurchaseOrderItemFilter } from '../data/purchaseOrderItem';

export function createPurchaseOrderItemService(client: AxiosInstance) {
  return createCrudService<PurchaseOrderItem, PurchaseOrderItemCreate, PurchaseOrderItemFilter>(client, "/purchase/PurchaseOrderLine", "purchaseOrderItemId");
}

export type PurchaseOrderItemService = CrudService<
  PurchaseOrderItem,
  PurchaseOrderItemCreate,
  PurchaseOrderItemFilter
>;
